import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'algaeColor'
})
export class AlgaeColorPipe implements PipeTransform {

  transform(value: number): string {
    if (value < 0.01){
      return 'red darken-3';
    }else if (value >= 0.01 && value <= 100 ){
      return 'yellow darken-2';
    }else if (value > 100 ){
      return 'green darken-1';
    }
    return ;
  }

}
